/**
 * useLogoReset — Reset dashboard filters / selections when the user clicks
 * the Drayly logo (which navigates to the same route with
 * `location.state.reset = <timestamp>`).
 *
 * Iter 265.2: production bug — clicking the logo while already on the
 * dashboard did nothing (Link no-op), so users were "stuck in filters"
 * with no way back to the default view except a full page refresh.
 */
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function useLogoReset(resetFn) {
  const location = useLocation();
  const lastResetRef = useRef(null);
  const resetRef = useRef(resetFn);
  resetRef.current = resetFn;

  useEffect(() => {
    const reset = location.state?.reset;
    if (!reset || reset === lastResetRef.current) return;
    lastResetRef.current = reset;
    try {
      resetRef.current?.();
    } catch (err) {
      // Never let a reset callback break the app.
      // eslint-disable-next-line no-console
      console.warn('useLogoReset callback threw', err);
    }
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.state]);
}
